import React from 'react';
import { cn } from '../../lib/utils';

function Badge({ className, variant = 'default', ...props }) {
    const variants = {
        default: 'bg-slate-100 text-slate-800',
        primary: 'bg-brand-100 text-brand-800',
        secondary: 'bg-secondary-100 text-secondary-800',
        success: 'bg-green-100 text-green-800',
        warning: 'bg-accent-100 text-accent-800',
        danger: 'bg-red-100 text-red-800',
        outline: 'border border-slate-200 text-slate-800',
    };

    return (
        <div
            className={cn(
                "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors",
                variants[variant],
                className
            )}
            {...props}
        />
    );
}

export { Badge };
